<script>
  import clsx from "clsx";
  let className = null;

  export let svgClass = "h-4 w-4 fill-current";
  export let viewBox = "0 0 512 512";
  export let disabled = false;
  export { className as class };
</script>

<button
  on:click
  type="button"
  {disabled}
  class={clsx(
    className,
    "relative flex w-full cursor-pointer items-center justify-center rounded-none border-0 bg-theme-minor-700 p-1 text-center text-sm font-medium text-white opacity-90 shadow transition-opacity focus:outline-none disabled:cursor-not-allowed hocus:opacity-100 hocus:shadow-md disabled:hocus:opacity-90",
  )}
>
  <span class="absolute inset-y-0 left-0 flex items-center pl-3">
    <svg xmlns="http://www.w3.org/2000/svg" {viewBox} class={svgClass}><slot name="path" /></svg>
  </span>
  <span class="whitespace-nowrap px-8"><slot /></span>
</button>
